module.exports = __webpack_public_path__ + "313ac828a8b0f7740921eb81e0d48be8.png";